/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import * as echarts from 'echarts/core';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { capitalize, getColor, rgbaColor } from 'helpers/utils';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { months } from 'data/month';

function WiseModalExchangeRate({ handleClose, ...props }) {
  const getOptions = (month, data) => ({
    color: getColor('gray-100'),
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-100'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      formatter: params => {
        const { name, value } = params[0];
        return `${month} ${name} : ${value}`;
      },
      transitionDuration: 0
    },
    xAxis: {
      type: 'category',
      data: [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23],
      boundaryGap: false,
      axisPointer: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'dashed'
        }
      },
      splitLine: { show: false },
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'dashed'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-400'),
        formatter: value => `${capitalize(month.slice(0, 3))} ${value}`,
        margin: 15
      }
    },
    yAxis: {
      type: 'value',
      axisPointer: { show: false },
      splitLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'dashed'
        }
      },
      boundaryGap: false,
      axisLabel: {
        show: true,
        color: getColor('gray-400'),
        margin: 15
      },
      axisTick: { show: false },
      axisLine: { show: false }
    },
    series: [
      {
        type: 'line',
        data,
        lineStyle: { color: getColor('primary') },
        itemStyle: {
          borderColor: getColor('primary'),
          borderWidth: 2
        },
        symbol: 'circle',
        symbolSize: 10,
        smooth: false,
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: rgbaColor(getColor('primary'), 0.2)
              },
              {
                offset: 1,
                color: rgbaColor(getColor('primary'), 0)
              }
            ]
          }
        }
      }
    ],
    grid: { right: 10, left: 0, bottom: 0, top: 10, containLabel: true }
  });

  const data = [
    ['product', 143, 835, 949, 453, 865, 997, 47, 858, 999, 403, 815, 919],
    ['Boots4', 43, 85, 99, 43, 85, 99, 99, 43, 85, 99, 43, 85, 99, 43, 85, 99],
    ['Reign Pro', 143, 835, 949, 453, 865, 997, 47, 858, 999, 403, 815, 919],
    ['Slick', 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 90, 92, 99, 90],
    ['Falcon', 43, 85, 99, 43, 85, 99, 99, 43, 85, 99, 43, 85, 99, 43, 85, 99],
    ['Sparrow', 143, 835, 949, 453, 865, 997, 47, 858, 999, 403, 815, 919],
    ['Hideaway', 143, 835, 949, 453, 865, 997, 47, 858, 999, 403, 815, 919],
    ['Freya', 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 90, 92, 99, 90]
  ];

  echarts.use([
    TitleComponent,
    TooltipComponent,
    GridComponent,
    LineChart,
    CanvasRenderer,
    LegendComponent
  ]);

  const [month, setMonth] = useState(0);
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="fs-1">
          We use the real exchange rate
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex className="justify-content-center justify-content-md-between">
          <p className="fs-0 mb-0">As of 1 min ago, 1 GBP → 1.15101 EUR</p>
          <p className="fs-0 mb-0 d-none d-md-block">
            <FontAwesomeIcon icon="minus" size="lg" className="me-3" />
            Mid market rate
            <a href="#" className="text-1000 text-decoration-none">
              <FontAwesomeIcon
                icon="question-circle"
                size="sm"
                className="ms-2"
              />
            </a>
          </p>
        </Flex>

        <div className="mt-4 mt-md-6 mb-4">
          <div className="mb-3">
            {months?.map((item, index) => (
              <Button
                variant={index !== month ? 'outline-primary' : 'primary'}
                className="rounded-pill me-1 mb-1"
                key={index}
                onClick={() => setMonth(index)}
              >
                {item}
              </Button>
            ))}
          </div>
          <ReactEChartsCore
            echarts={echarts}
            option={getOptions(months[month], data[month])}
            style={{ height: '18.4375rem' }}
          />
        </div>

        <div className="text-center mt-3">
          <Button
            as="a"
            href="#"
            variant="outline-primary"
            className="rounded-pill me-1 mb-1"
          >
            Track this exchange rate
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default WiseModalExchangeRate;
